const later = (delay, value) => {
  return new Promise((resolve) => setTimeout(resolve, delay, value))
}

export default later
